import { jsx as _jsx } from "react/jsx-runtime";
import * as S from "./TextContainer.styled";
export var TextContainer = function (_a) {
    var spacing = _a.spacing, children = _a.children;
    return _jsx(S.Wrap, { spacing: spacing, children: children });
};
